import { render, staticRenderFns } from "./HeaderPickupPoints.vue?vue&type=template&id=6d567a6e&"
import script from "./HeaderPickupPoints.vue?vue&type=script&lang=js&"
export * from "./HeaderPickupPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports